<template>
  <div class="lb-bloco " :style="fundo != '' ? 'background-color:' + fundo : ''">
<!--    <h7 class="waves-effect" :style="descricao ? 'margin-top: 0' : ''">-->
    <span class="waves-effect" :style="descricao ? 'margin-top: 0' : ''">
      <strong style="font-weight: bold">{{titulo}}</strong>
<!--    </h7>-->
    </span>
    <slot></slot>
    <div>{{descricao}}</div>
  </div>
</template>

<script>
export default {
  name: "TituloDestacado",
  props: ["titulo", "descricao","fundo"]
};
</script>

<style scoped>
.lb-bloco {
  position: relative;
  background-color: #f2f2f2;
  padding: 12px 10px 12px 15px;
  border: 1px solid;
}
.lb-bloco > h6 {
  margin: 0;
}
.lb-bloco.lb-grupo > h6 {
  font-size: 1.5em;
}
</style>



// WEBPACK FOOTER //
// src/components/Widgets/TituloDestacado.vue